var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5157_23953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0922 2.59464L14.0851 3.38214C12.7118 1.62679 10.5761 0.5 8.17791 0.5C4.03684 0.5 0.685051 3.84821 0.679694 7.99107C0.674337 12.1375 4.03327 15.5 8.17791 15.5C11.4154 15.5 14.1743 13.4464 15.2243 10.5696C15.2511 10.4946 15.2118 10.4107 15.1368 10.3857L14.1243 10.0375C14.089 10.0254 14.0504 10.0276 14.0167 10.0436C13.983 10.0596 13.9569 10.0882 13.944 10.1232C13.9118 10.2125 13.8761 10.3018 13.8386 10.3893C13.5297 11.1214 13.0868 11.7786 12.5226 12.3429C11.9628 12.9036 11.3001 13.3511 10.5708 13.6607C9.81541 13.9804 9.01005 14.1429 8.18148 14.1429C7.35112 14.1429 6.54755 13.9804 5.79219 13.6607C5.06215 13.3524 4.39919 12.9048 3.84041 12.3429C3.27916 11.7832 2.83216 11.1197 2.52434 10.3893C2.20469 9.63214 2.04219 8.82857 2.04219 7.99822C2.04219 7.16786 2.20469 6.36429 2.52434 5.60714C2.83327 4.875 3.27612 4.21786 3.84041 3.65357C4.40469 3.08929 5.06184 2.64643 5.79219 2.33571C6.54755 2.01607 7.35291 1.85357 8.18148 1.85357C9.01184 1.85357 9.81541 2.01607 10.5708 2.33571C11.3008 2.64401 11.9638 3.09164 12.5226 3.65357C12.6993 3.83036 12.8654 4.01786 13.019 4.21429L11.944 5.05357C11.9227 5.07003 11.9065 5.09215 11.8973 5.1174C11.888 5.14265 11.8861 5.16999 11.8917 5.1963C11.8973 5.2226 11.9102 5.24679 11.9289 5.26608C11.9476 5.28537 11.9714 5.29899 11.9976 5.30536L15.1333 6.07322C15.2226 6.09464 15.3101 6.02679 15.3101 5.93572L15.3243 2.70536C15.3226 2.5875 15.1851 2.52143 15.0922 2.59464Z",
    fill: "#096DD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5157_23953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/Reload.85818f4cc667e8a6f44d7cea45bba44e.svg";
export { ForwardRef as ReactComponent };